class API {
  constructor() {
    this.url =
      "https://script.google.com/macros/s/AKfycbwjw5_g0XO6sTZ0lMFnVH5Z44VYczuLPnlZlwXxl7hfUHLVhHbu3apPikBOMZD3aQHH/exec";
      // "https://script.google.com/macros/s/AKfycbyqds0fs0lLUb390C2wadRsbPAKoWjX0md-C44xWGVGwcNsJKoCYDyIE4F8-h-qI_DO/exec";
  }

  async push(feedbackData) {
    const data = JSON.stringify(feedbackData);

    return fetch(this.url, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
  }
}

export default API;
